module.exports = __webpack_public_path__ + "img/participant-segments-icon-active.dee5c683.svg";